import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'buscacliente',
    templateUrl: './buscacliente.component.html',
    styleUrls: ['./buscacliente.component.scss'],
})
export class BuscaclienteComponent implements OnInit {
    @Input() data: any = [];
    @Output() sign = new EventEmitter();
    public term: string;
    public list: any = [];

    constructor() {}

    ngOnInit(): void {
        this.list = this.data;
    }

    public preencher(list) {
        this.list = list;
    }

    public select(item) {
        this.sign.emit(item);
    }

    public search() {
        if (this.term) {
            this.list = this.data.filter(
                (item) =>
                    String(item.dscliente)
                        .toUpperCase()
                        .indexOf(String(this.term).toUpperCase()) > -1
            );
        } else {
            this.list = this.data;
        }
    }
}
